/// <reference path="../../../typings/tsd.d.ts" /> 
enum ComparisonOperator {
    Equals = 0,
    NotEquals = 1,
    GreaterThan=2,
    LessThan = 3,
    GreaterThanOrEqual = 4,
    LessThanOrEqual=5    
}